import React, {PropTypes} from 'react';
import keycode from 'keycode';
import perfectScrollbar from 'perfect-scrollbar';
import eventlistener from 'eventlistener';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import classNames from 'classnames';

import Icon from 'icons/icon';
import BaseButton from 'buttons/base-button';
import controlElements from 'utils/control-elements';

import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import styles from './dialog.less';
import scrollStyles from 'app/styles/perfect-scrollbar.less';

class Dialog extends React.Component {

  constructor(props) {
    super(props);
    this._closeButtonTabIndex = 10100;
    this._tempClickTarget = null; // because of 'bubbling' we use two events: onMouseDown(save target) and onClick(check, close and clear target)
    this._previousProps = {};
  }

  static defaultProps = {
    autoFocus: true,
    hasInnerScrollX: true,
    hasInnerScrollY: true,
    hasOuterScrollX: false,
    hasOuterScrollY: false
  }

  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    actions: PropTypes.arrayOf(React.PropTypes.element),
    header: PropTypes.string.isRequired,
    minHeight: PropTypes.number,
    minWidth: PropTypes.number,
    autoFocus: PropTypes.bool,
    hasInnerScrollX: PropTypes.bool,
    hasInnerScrollY: PropTypes.bool,
    hasOuterScrollX: PropTypes.bool,
    hasOuterScrollY: PropTypes.bool
  }

  componentDidUpdate() {
    if (!this._previousProps.active && this.props.active) {
      this.initScrollbar();
      this.focusFirstControl(this.props.autoFocus);
      this.manageHandlers(true);
    }
    if (this._previousProps.active && !this.props.active) {
      this.manageHandlers(false);
    }
    Object.assign(this._previousProps, this.props);
  }

  componentWillUnmount() {
    this.manageHandlers(false);
  }

  manageHandlers(add) {
    var action = add ? 'add' : 'remove';

    document.body.classList[action]('modal-open');
    eventlistener[action](window, 'resize', this.updateScrollbar.bind(this));
    eventlistener[action](window, 'keydown', this.handleKeyDown.bind(this));
  }

  initScrollbar() {
    perfectScrollbar.initialize(this.refs.modalBody, this.getScrollbarOptions());
    new ResizeSensor(this.refs.modalScrolledArea, this.updateScrollbar.bind(this));
  }

  focusFirstControl(shouldFocus) {
    if (!shouldFocus) return;

    var firstControl = this.refs.modalBody.querySelectorAll(controlElements.join(', '))[0];
    if (firstControl) firstControl.focus();
  }

  updateScrollbar() {
    var modalBody = this.refs.modalBody;
    perfectScrollbar.update(modalBody, this.getScrollbarOptions());
  }

  getScrollbarOptions() {
    return {
      scrollXMarginOffset: 10,
      scrollYMarginOffset: 10,
      suppressScrollX: !this.props.hasInnerScrollX,
      suppressScrollY: !this.props.hasInnerScrollY
    };
  }

  getOverflowStyles() {
    return {
      overflowX: this.props.hasOuterScrollX ? 'auto' : 'hidden',
      overflowY: this.props.hasOuterScrollY ? 'auto' : 'hidden'
    };
  }

  handleModalMoseDown(e) {
    this._tempClickTarget = e.target;
  }

  handleModalClick(e) {
    if (e.target == this.refs.modal && this._tempClickTarget === e.target) {
      this.props.onRequestClose();
    }
    this._tempClickTarget = null;
  }

  handleKeyDown(e) {
    if (keycode(e) === 'esc') {
      this.props.onRequestClose();
    }
  }

  render() {
    if (!this.props.active) return null;

    let actions = this.props.actions.map((action, index) => <span className="modal-footer-action" key={index}>{action}</span>);

    let modalStyles = classNames(styles.modal, scrollStyles.scrollbar);

    return (
      <div>
        <div  ref="modal"
              className={modalStyles}
              onClick={this.handleModalClick.bind(this)}
              onMouseDown={this.handleModalMoseDown.bind(this)}
              style={this.getOverflowStyles()}>
          <div className={styles.content} style={{minWidth: this.props.minWidth}}>
            <header className={styles.header}>
              <h3 className={styles.headerText}>{this.props.header}</h3>
              <BaseButton type="button"
                          className={styles.closeIcon}
                          tabIndex={this._closeButtonTabIndex}
                          onClick={this.props.onRequestClose.bind(this)}>
                <Icon icon="icon-multiple-sign" />
              </BaseButton>
            </header>
            <main ref="modalBody" className={styles.main} style={{minHeight: this.props.minHeight}}>
              <div ref="modalScrolledArea">
                {this.props.children}
              </div>
            </main>
            <footer className={styles.footer}>
              {actions}
            </footer>
          </div>
        </div>
        <div className={styles.overlay}></div>
      </div>
    );
  }
}

module.exports = Dialog;


/** WEBPACK FOOTER **
 ** ./src/dialogs/dialog/index.js
 **/